import { Action } from 'redux';
import { MasterData } from 'types/MasterData';

export const MASTER_DATA_RESET_ACTION_TYPE = 'masterdata/reset';
export const MASTER_DATA_FETCH_START_ACTION_TYPE = 'masterdata/fetch_start';
export const MASTER_DATA_FETCH_SUCCESS_ACTION_TYPE = 'masterdata/fetch_success';
export const MASTER_DATA_ERROR_ACTION_TYPE = 'masterdata/error';

interface MasterDataResetAction extends Action<typeof MASTER_DATA_RESET_ACTION_TYPE> {}

interface MasterDataFetchStartAction extends Action<typeof MASTER_DATA_FETCH_START_ACTION_TYPE> {}

interface MasterDataFetchSuccessAction
    extends Action<typeof MASTER_DATA_FETCH_SUCCESS_ACTION_TYPE> {
    payload: {
        masterData: MasterData;
    };
}

interface MasterDataErrorAction extends Action<typeof MASTER_DATA_ERROR_ACTION_TYPE> {}

export type MasterDataAction =
    | MasterDataResetAction
    | MasterDataFetchStartAction
    | MasterDataFetchSuccessAction
    | MasterDataErrorAction;
